$("#detail-slider").slick({
    slidesToShow: 1,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 5000,
    prevArrow: "<button type='button' class='slick-prev icon-chevron-left'></button>",
    nextArrow: "<button type='button' class='slick-next icon-chevron-right'></button>"
});